module.exports = __webpack_public_path__ + "media/components/Sponsors/FormTags/Categories/24-1c1f051581d4434c846e2d29ceb23d2b.png";